export const BRAND = {
  name: "M4MMON",
  descriptor: "Strategy evidence workspace",
  supportEmail: "access@m4mmon.app",
} as const;

export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "");
